module.exports = __webpack_public_path__ + "img/Columns.25206a88.svg";